<template>
	<div class="progressbar">
		<div
			:class="barClass"
			:style="barStyle"
			class="progressbar-bar">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    barClass: {
      type: String,
      default: ''
    },
    origin: {
      type: String,
      default: 'left'
    },
    scale: {
      type: String,
      default: 'X',
      validator: v => ['X', 'Y'].includes(v)
    }
  },
  data () {
    return {
      ready: false
    }
  },
  computed: {
    barStyle () {
      if (!this.ready) {
        return {
          transform: `scale${this.scale}(0)`
        }
      }

      return {
        transform: `scale${this.scale}(${this.value * 0.01})`,
        transformOrigin: `${this.origin}`
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.ready = true
    }, 0)
  }
}
</script>
<style lang="scss" scoped>
.progressbar {
	height: 1rem;
	overflow: hidden;
	background: #A3C2EA;
	border-radius: 4px;

	&-bar {
		height: 100%;
		background: #25568D;
		transition: transform 3s ease;
		border-radius: 4px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Elements/ProgressBar.vue